import React from "react";
import { Navigate, useSearchParams } from "react-router-dom";

/** Alias `/accept-invite?token=xxx` → `/invite/xxx` so both link shapes work. */
export default function AcceptInviteAlias() {
  const [sp] = useSearchParams();
  const token = sp.get("token");
  if (!token) return <Navigate to="/login" replace />;
  return <Navigate to={`/invite/${encodeURIComponent(token)}`} replace />;
}
